import React 			from 'react';
import ReactDOM 		from 'react-dom';
import moment from 'moment';

import BLComponent		from '../../core/_BLComponent.jsx';

import CrowdNavigation 	from '../common/_CrowdNavigation.jsx';
import SeriesInternalNav from '../common/_SeriesInternalNav.jsx';

import CrowdSubmissionResults from './_CrowdSubmissionResults.jsx';

import TimelineContent from './_TimelineContent.jsx';
import BDPHeader from '../common/_BDPHeader.jsx';

export default class CrowdSeriesPostValidation extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
		};

		this.series 				= blapp.models.get('listSeries') || [];
		this.seriesNumber 	= parseInt(blapp.util.getUrlInfo(window.location.href).path.split('/')[3].split('-')[1]); 
		this.seriesContent 	= this.series[this.series.findIndex(series => series.idSeries == this.seriesNumber)];
	}

	render() {
		return (
			<React.Fragment>
				{!blapp.config.isDesktopMode() ? <CrowdNavigation page={1}/> : null}
				<BDPHeader series/>
				<SeriesInternalNav classes="bdp-series-main__series-nav-landing"/>
				<div className="main">
					<div className="main__content">
						{this.renderIntroBlock()}
						<CrowdSubmissionResults/>
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderIntroBlock() {
		return (
			<article className="bdp-series-main__intro-block l-block">
				<div className="bdp-series-main__intro-block-content bdp-series-main__intro-block-content--validation text--center">
					<h1 className="bdp-series-main__intro-title">Crowd Support voting is now closed.</h1>
					<p className="text-color--darkestBlue bdp-series-main__intro-text">The BDP Design Team will review all designs and pick 5 finalists. Check back on <strong>{moment(this.seriesContent.udtDesignsAnnounced).format("MMMM Do")}</strong> to find out which we choose!</p>
				</div>
				<section className="bdp-series-timeline__container">
					<TimelineContent type="post-validation"/>
				</section>
			</article>
		);
	}
};